import React from 'react';
import { Divider, List, ListItem, ListItemButton, ListItemText, Chip } from '@mui/material';
import useLocales from '../../../hooks/useLocales';
import { AuthMethod, EmailTemplateTypeModel } from '../../../common/enums';
import { getIdentityClientSettings } from '../../../utils/localStorage';
import { EmailTemplateEditorModel } from '../../../common/Interfaces';
import { emailTemplateTypeIdToName } from '../../../common/constants';

interface IdmEmailTemplateListProps {
    handleShowEdit(templateType: number): void;
    templates: EmailTemplateEditorModel[];
}

export default function IdmEmailTemplateList({ handleShowEdit, templates }: IdmEmailTemplateListProps) {
    const authMethod = getIdentityClientSettings().authMethod;
    const { translate } = useLocales();

    const visibleTypes = React.useMemo(() => {
        if (authMethod === AuthMethod.IDM) {
            return [
                EmailTemplateTypeModel.UserCreationTemplate,
                EmailTemplateTypeModel.UserBackendAssignmentAddedTemplate,
                EmailTemplateTypeModel.CustomerPortalInviteTemplate,
                EmailTemplateTypeModel.WebOfficeInviteTemplate,
                EmailTemplateTypeModel.ForgottenPasswordTemplate,
            ];
        } else {
            return [
                EmailTemplateTypeModel.CustomerPortalInviteTemplate,
                EmailTemplateTypeModel.VerificationCode,
            ];
        }
    }, [authMethod]);

    const renderOriginChip = (templateType: number) => {
        const custom = templates.find(t => t.templateType === templateType);
        const isCustom = !!custom && custom.enabled;

        return (
            <Chip
                label={translate(
                    isCustom
                        ? 'IdmEmailTemplate.Custom'
                        : 'IdmEmailTemplate.Default'
                )}
                style={{
                    width: '70px',
                    marginRight: '20%',
                    background: isCustom ? '#03a9f4' : '#30a954',
                    color: 'white',
                    fontSize: '10px',
                }}
                size="small"
            />
        );
    };

    return (
        <List style={{ maxHeight: '90%', overflow: 'auto' }}>
            {visibleTypes.map((type, idx) => (
                <React.Fragment key={type}>
                    <ListItemButton
                        disableRipple
                        onClick={() => handleShowEdit(type)}
                        style={
                            idx % 2 === 0
                                ? { background: 'white' }
                                : { background: '#f4f6f8' }
                        }
                    >
                        <ListItem>
                            <ListItemText
                                primary={emailTemplateTypeIdToName(type)}
                            />
                            {renderOriginChip(type)}
                        </ListItem>
                    </ListItemButton>
                    <Divider />
                </React.Fragment>
            ))}
        </List>
    );
}